import { BrandConfig } from '../types'

export const fightforyouConfig: BrandConfig = {
  // アプリケーション基本情報
  appName: 'FIGHT 4 YOU',
  appUrl: 'https://fightforyou.jp',
  hashtag: 'fightforyou',
  metaDescription: 'あなたの応援したい人を支援できるプラットフォーム。写真や動画などのデジタルコンテンツでお届けします。',

  // お問い合わせ・サポートURL（fightforyou固有のURLが決まったら更新）
  contactUrl: 'https://pintoforyou.tayori.com/form/2e885e81dd85afd3277dfbfd4493b399c8628682/',
  userFaqUrl: 'https://pintoforyou.tayori.com/faq/799ebccea5fee140eaf1348ce6e676ca596723f7/',
  creatorAndBusinessFaqUrl: 'https://pintoforyou.tayori.com/faq/d792e109555222f2bb1899de9733037f47ea9935/',
  creatorRegistrationUrl: 'https://pintoforyou.tayori.com/form/b18a16abb63394135454b51a6e37a231b73330bd/',
  creatorBankAccountRegistrationUrl: 'https://pintoforyou.tayori.com/form/98297dfcac82c4ddd1773b340af605a8f2dd0f6f/',

  // ソーシャルメディアURL
  socialTwitterUrl: 'https://x.com/Fight4Y37274',
  socialFacebookUrl: '',
  socialInstagramUrl: 'https://www.instagram.com/fight4you2026/',
  socialYoutubeUrl: '',

  // ブランド固有の設定（カラーは後で調整）
  primaryColor: '#ff4444',
  secondaryColor: '#ff8888',
}
